type RouteData = {
    path: string;
    title: string;
};

export const navItemsData: { [key: string]: RouteData; } = {
    home: { path: "/", title: "sketch" },
    dsp: { path: "/soundsynth", title: "audio synthesizer" },
    contact: { path: "/contact", title: "contact" }
};
